import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api/bwm',
  headers: { 'x-api-key': process.env.REACT_APP_API_KEY || '' },
});

const authHeader = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
});

export const getServices = () =>
  api.get('/services').then((r) => r.data);

export const getService = (token, id) =>
  api.get(`/services/${id}`, authHeader(token)).then((r) => r.data);

export const createService = (token, payload) =>
  api.post('/services', payload, authHeader(token)).then((r) => r.data);

export const updateService = (token, id, payload) =>
  api.put(`/services/${id}`, payload, authHeader(token)).then((r) => r.data);

export const deleteService = (token, id) =>
  api.delete(`/services/${id}`, authHeader(token)).then((r) => r.data);
